import { locationSuggestionNotAvailable } from 'owa-locstrings/lib/strings/locationsuggestionnotavailable.locstring.json';
import { locationSuggestionRecurringAvailability } from 'owa-locstrings/lib/strings/locationsuggestionrecurringavailability.locstring.json';
import { locationSuggestionRecurringPartialAvailability } from 'owa-locstrings/lib/strings/locationsuggestionrecurringpartialavailability.locstring.json';
import { availableFreeBusy } from 'owa-locstrings/lib/strings/availablefreebusy.locstring.json';
import loc, { format } from 'owa-localize';

export default function getRecurrenceAvailabilityTextAndStyle(
    numberOfAvailableTimeSlots: number,
    totalNumberOfTimeSlots: number,
    isPartialAvailability: boolean,
    freeStyle: string,
    busyStyle: string
): { text: string; textStyle: string } {
    let freebusyText: string = null;
    let freebusyStyle: string = null;

    if (numberOfAvailableTimeSlots == 0) {
        freebusyText = loc(locationSuggestionNotAvailable);
        freebusyStyle = busyStyle;
    } else if (numberOfAvailableTimeSlots == totalNumberOfTimeSlots && !isPartialAvailability) {
        freebusyText = loc(availableFreeBusy);
        freebusyStyle = freeStyle;
    } else {
        const availabilityStringFormat = isPartialAvailability
            ? loc(locationSuggestionRecurringPartialAvailability)
            : loc(locationSuggestionRecurringAvailability);
        freebusyText = format(
            availabilityStringFormat,
            numberOfAvailableTimeSlots,
            totalNumberOfTimeSlots
        );
        freebusyStyle = freeStyle;
    }

    return { text: freebusyText, textStyle: freebusyStyle };
}
